<template>
	<div style="padding: 10px 10px 10px 0;" v-loading="loading">
		<el-form :inline="true" :model="sf" class="demo-form-inline">
			<el-form-item label="合同名称">
				<el-input v-model="sf.contractName" placeholder="合同名称" style="width: 120px;"></el-input>
			</el-form-item>
			<el-form-item label="合同状态">
				<el-select v-model="sf.contractStatus" placeholder="合同状态" style="width: 120px;" clearable>
					<el-option label="已终止" value="已终止"></el-option>
					<el-option label="执行中" value="执行中"></el-option>
					<el-option label="合同变更中" value="合同变更中"></el-option>
					<el-option label="合同续签中" value="合同续签中"></el-option>
					<el-option label="补充协议中" value="补充协议中"></el-option>
					<el-option label="合同解约中" value="合同解约中"></el-option>
					<el-option label="合同申请中" value="合同申请中"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="楼层">
				<el-select v-model="sf.floor" placeholder="楼层" style="width: 120px;" clearable>
					<el-option v-for="item in 5" :label="`${item}层`" :value="`${item}层`"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="审核状态">
				<el-select v-model="sf.applyStatus" placeholder="审核状态" style="width: 120px;" clearable>
					<el-option label="审核中" value="审核中"></el-option>
					<el-option label="审核成功" value="审核成功"></el-option>
					<el-option label="审核失败" value="审核失败"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="签约时间">
				<el-date-picker v-model="sf.qianyueTime" type="date" placeholder="选择日期" style="width: 150px;">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll()">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="addRow()">新增</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="dc">导出</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="number" label="合同编号"></el-table-column>
			<el-table-column prop="contractName" label="合同名称"></el-table-column>
			<el-table-column prop="contactLimit" label="合同期限"></el-table-column>
			<el-table-column prop="qianyueTime" label="签约日期">
				<teleport slot-scope="{row}">{{row.qianyueTime.split("T")[0]}}</teleport>
			</el-table-column>
			<el-table-column prop="endingTime" label="到期时间">
				<teleport slot-scope="{row}">{{row.endingTime.split("T")[0]}}</teleport>
			</el-table-column>
			<el-table-column prop="contractStatus" label="合同状态">
				<teleport slot-scope="{row}">
					<div class="flex" style="align-items: center;">
						<span style="margin-right: 10px;">{{row.contractStatus}}</span>
						<div v-if="row.contractStatus=='执行中'"
							style="width: 8px;height: 8px;border-radius: 4px;background: #008000;"></div>
						<div v-else-if="row.contractStatus=='已终止'"
							style="width: 8px;height: 8px;border-radius: 4px;background: red;"></div>
						<div v-else style="width: 8px;height: 8px;border-radius: 4px;background: darkorange;"></div>
					</div>
				</teleport>
			</el-table-column>
			<el-table-column prop="floor" label="楼层"></el-table-column>
			<el-table-column prop="shops" label="商铺号"></el-table-column>
			<!-- <el-table-column prop="applyStatus" label="审核状态"></el-table-column> -->
			<el-table-column prop="createTime" label="操作时间">
				<template slot-scope="{row}">
					{{row.createTime.split('T')[0]}} {{row.createTime.split('T')[1].split(".")[0]}}
				</template>
			</el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="getRow(row,'look')">查看</el-button>
					<el-button v-if="row.contractStatus=='执行中'" type="text" @click="getRow(row,'set')">变更</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="sf.rows" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
		</el-pagination>
		<!-- 新增变更 -->
		<el-dialog :title="title" :visible.sync="show" width="50%" top="50px">
			<div v-show="title!='新增'" class="b">原合同</div>
			<el-form ref="form" :model="form" label-width="100px">
				<el-form-item label="品牌名称">
					<el-input :disabled="title[0]!='新'" v-model="form.brandName"></el-input>
				</el-form-item>
				<el-form-item label="品牌联系人">
					<el-input :disabled="title[0]!='新'" v-model="form.linkName"></el-input>
				</el-form-item>
				<el-form-item label="联系电话">
					<el-input :disabled="title[0]!='新'" v-model="form.linkPhone"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input :disabled="title[0]!='新'" v-model="form.linkCard"></el-input>
				</el-form-item>
				<el-form-item label="银行账号">
					<el-input :disabled="title[0]!='新'" v-model="form.bankNum"></el-input>
				</el-form-item>
				<el-form-item label="签约时间">
					<el-date-picker :disabled="title[0]!='新'" v-model="form.qianyueTime" type="date" placeholder="签约时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="到期时间">
					<el-date-picker :disabled="title[0]!='新'" v-model="form.endingTime" type="date" placeholder="签约时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="所属楼层">
					<el-select :disabled="title[0]!='新'" v-model="form.floor" placeholder="所属楼层">
						<el-option v-for="item in 5" :label="`${item}层`" :value="`${item}层`"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商铺号">
					<el-select :disabled="title[0]!='新'" v-model="form.shops" placeholder="商铺号">
						<el-option v-for="item in nums" :label="item.shopNum" :value="item.shopNum"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="业态标签">
					<el-select :disabled="title[0]!='新'" v-model="form.formatsTags" placeholder="请选择" multiple
						style="width: 100%;">
						<el-option-group v-for="group in options" :key="group.label" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="合同名称">
					<el-input :disabled="title[0]!='新'" v-model="form.contractName"></el-input>
				</el-form-item>
				<el-form-item label="合同限制">
					<el-input v-model="form.contactLimit" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="付款周期">
					<el-input :disabled="title[0]!='新'" v-model="form.paymentCycle"></el-input>
				</el-form-item>
				<el-form-item label="租金收取方式">
					<el-select :disabled="title[0]!='新'" v-model="form.zjsqType" placeholder="租金收取方式">
						<el-option label="季付" value="季付"></el-option>
						<el-option label="月付" value="月付"></el-option>
						<el-option label="按比例收取" value="按比例收取"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="租金金额">
					<el-input :disabled="title[0]!='新'" v-model="form.zjsqJe"></el-input>
				</el-form-item>
				<el-form-item label="品牌描述">
					<el-input :disabled="title[0]!='新'" v-model="form.linkDescribe"></el-input>
				</el-form-item>
				<el-form-item label="意向书附件">
					<el-upload v-if="title[0]=='新'" action="/api/admin/contract/uploadContractAttachment" name="file"
						:show-file-list="false" :on-success="success2" :headers="headerData">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<span style="color: #3C98FF;" @click="down(form.contractYxs)">{{form.contractYxsFilename}}</span>
				</el-form-item>


				<el-form-item label="合同附件">
					<el-upload v-if="title[0]=='新'" action="/api/admin/contract/uploadContractAttachment" name="file"
						:show-file-list="false" :on-success="success" :headers="headerData">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
					<span style="color: #3C98FF;" @click="down(form.contractAttachment)">{{form.contractAttachmentFilename}}</span>
				</el-form-item>
			</el-form>
			<div v-show="title=='变更'">
				<div class="b">选择合同变更类型</div>
				<el-tabs v-model="name">
					<el-tab-pane label="合同变更" name="合同变更">
						<div class="b">新合同</div>
					</el-tab-pane>
					<el-tab-pane label="合同续签" name="合同续签">
						<div class="b">新合同</div>
					</el-tab-pane>
					<el-tab-pane label="补充协议" name="补充协议">
						<div class="b">新合同</div>
					</el-tab-pane>
					<el-tab-pane label="合同解约" name="合同解约">
						<el-form ref="bg" :model="bg" label-width="100px">
							<el-form-item label="解约原因">
								<el-input v-model="bg.terminationReason"></el-input>
							</el-form-item>
							<el-form-item label="合同附件">
								<el-upload action="/api/admin/contract/uploadContractAttachment" name="file"
									:show-file-list="false" :on-success="success" :headers="headerData">
									<el-button size="small" type="primary">点击上传</el-button>
								</el-upload>
								<span style="color: #3C98FF;" @click="down(bg.contractAttachment)">{{bg.contractAttachmentFilename}}</span>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</el-tabs>
				<el-form ref="bg" :model="bg" label-width="100px" v-if="name!='合同解约'">
					<el-form-item label="品牌名称">
						<el-input v-model="bg.brandName" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="品牌联系人">
						<el-input v-model="bg.linkName" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="联系电话">
						<el-input v-model="bg.linkPhone" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="身份证号">
						<el-input :disabled="title[0]!='新'" v-model="bg.linkCard"></el-input>
					</el-form-item>
					<el-form-item label="银行账号">
						<el-input :disabled="title[0]!='新'" v-model="bg.bankNum"></el-input>
					</el-form-item>
					<el-form-item label="签约时间">
						<el-date-picker v-model="bg.qianyueTime" type="date" placeholder="签约时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="到期时间">
						<el-date-picker v-model="bg.endingTime" type="date" placeholder="签约时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="所属楼层">
						<el-select v-model="bg.floor" placeholder="所属楼层" :disabled="name=='合同续签'">
							<el-option v-for="item in 5" :label="`${item}层`" :value="`${item}层`">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商铺号">
						<el-select :disabled="true" v-model="bg.shops" placeholder="商铺号">
							<el-option v-for="item in nums" :label="item.shopNum" :value="item.shopNum">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="业态标签">
						<el-select v-model="bg.formatsTags" placeholder="请选择" multiple style="width: 100%;"
							:disabled="name=='合同续签'">
							<el-option-group v-for="group in options" :key="group.label" :label="group.label">
								<el-option v-for="item in group.options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-option-group>
						</el-select>
					</el-form-item>
					<el-form-item label="合同名称">
						<el-input v-model="bg.contractName" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="合同限制">
						<el-input v-model="bg.contactLimit" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="付款周期">
						<el-input v-model="bg.paymentCycle" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="租金收取方式">
						<el-select v-model="bg.zjsqType" placeholder="租金收取方式" :disabled="name=='合同续签'">
							<el-option label="季付" value="季付"></el-option>
							<el-option label="月付" value="月付"></el-option>
							<el-option label="按比例收取" value="按比例收取"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="租金金额">
						<el-input v-model="bg.zjsqJe" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="品牌描述">
						<el-input v-model="bg.linkDescribe" :disabled="name=='合同续签'"></el-input>
					</el-form-item>
					<el-form-item label="补充协议">
						<el-input v-model="bg.extraXieyi" :disabled="name=='合同续签'||name=='合同变更'"></el-input>
					</el-form-item>
					<el-form-item label="意向书附件">
						<el-upload action="/api/admin/contract/uploadContractAttachment" name="file" :show-file-list="false"
							:on-success="success2" :headers="headerData">
							<el-button size="small" type="primary" v-show="name!='合同续签'">点击上传</el-button>
						</el-upload>
						<span style="color: #3C98FF;" @click="down(bg.contractYxs)">{{bg.contractYxsFilename}}</span>
					</el-form-item>
					<el-form-item label="合同附件">
						<el-upload action="/api/admin/contract/uploadContractAttachment" name="file" :show-file-list="false"
							:on-success="success" :headers="headerData">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
						<span style="color: #3C98FF;" @click="down(bg.contractAttachment)">{{bg.contractAttachmentFilename}}</span>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="ok">{{title=="变更"?"提交":"确 定"}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		options
	} from "./data.js"
	import publicExport from '../../assets/js/publicExport.js';
	import downloadFile from '../../assets/js/downloadFile.js';
	export default {
		data() {
			return {
				loading: false,
				options,
				headerData: {
					Authorization: localStorage.access_token
				},
				nums: [], //商铺号
				sf: {
					page: 1,
					rows: 10,
					contractName: "", // 合同名称
					contractStatus: "", // 合同状态
					floor: "", // 楼层
					applyStatus: "", // 审核状态
					qianyueTime: "", // 签约日期
				},
				data: [],
				count: 0,
				title: "新增",
				name: "合同变更",
				show: false,
				bg: {},
				oldBg: "",
				oldForm: "",
				form: {
					linkCard: "",
					zjsqJe: "", //租金金额
					zjsqType: "", //租金收取方式
					bankNum: "", //
					floor: "", //所属楼层
					shops: "", //商铺号
					formatsTags: "", //业态标签
					brandName: "", //品牌名称
					qianyueTime: "", //签约时间
					endingTime: "", //到期时间
					contractName: "", //合同名称
					contactLimit: "", //合同限制
					paymentCycle: "", //付款周期
					linkName: "", //品牌联系人
					linkPhone: "", //联系电话
					linkDescribe: "", //品牌描述
					contractAttachment: "", //合同附件路径
					contractAttachmentFilename: "", //文件名
					contractYxs: "",
					contractYxsFilename: ""
				},
			}
		},
		watch: {
			name() {
				this.bg = JSON.parse(JSON.stringify(this.oldBg))
			},
			"form.qianyueTime"(val) {
				if (this.form.qianyueTime && this.form.endingTime) {
					let start = new Date(this.form.qianyueTime).getTime()
					let end = new Date(this.form.endingTime).getTime()
					this.form.contactLimit = (end - start) / 1000 / 60 / 60 / 24 + "天"
				}
			},
			"form.endingTime"(val) {
				if (this.form.qianyueTime && this.form.endingTime) {
					let start = new Date(this.form.qianyueTime).getTime()
					let end = new Date(this.form.endingTime).getTime()
					this.form.contactLimit = (end - start) / 1000 / 60 / 60 / 24 + "天"
				}
			},
			"bg.qianyueTime"(val) {
				if (this.bg.qianyueTime && this.bg.endingTime) {
					let start = new Date(this.bg.qianyueTime).getTime()
					let end = new Date(this.bg.endingTime).getTime()
					this.bg.contactLimit = (end - start) / 1000 / 60 / 60 / 24 + "天"
				}
			},
			"bg.endingTime"(val) {
				if (this.bg.qianyueTime && this.bg.endingTime) {
					let start = new Date(this.bg.qianyueTime).getTime()
					let end = new Date(this.bg.endingTime).getTime()
					this.bg.contactLimit = (end - start) / 1000 / 60 / 60 / 24 + "天"
				}
			},
		},
		methods: {
			down(url) {
				let name = url.split("\\")[url.split("\\").length-1]
				downloadFile({url,name})
			},
			dc() {

				let qianyueTime = ""
				if (this.sf.qianyueTime) {
					qianyueTime = new Date(this.sf.qianyueTime)
				}
				publicExport("/api/export/exportZsContract", {
					...this.sf,
					qianyueTime
				}, "招商合同")
			},
			handleCurrentChange(val) {
				this.sf.page = val;
				this.getAll()
			},
			handleSizeChange(val) {
				this.sf.rows = val;
				this.getAll()
			},
			getRow(row, type) {
				this.title = "变更"
				if (type == 'look') {
					this.title = "查看"
				}
				this.show = true
				this.form = {
					...row,
					formatsTags: JSON.parse(row.formatsTags)
				}
				this.bg = {
					...row,
					formatsTags: JSON.parse(row.formatsTags),
					contractAttachment: "",
					contractAttachmentFilename: "",
					// extraXieyi: "", //补充协议
					// terminationReason: "" //解约原因
				}
				this.oldBg = JSON.parse(JSON.stringify(this.bg))
			},
			xa(obj) {
				this.$http.post(`/api/oa/contract/newProcess`, {
					// ...this.form,
					"processKey": "contractChange",
					"startUserId": obj.startUserId,
					"managerId": "2",
					"number": obj.number,
					...obj
				}).then(res => {
					this.$http.post("/api/oa/contract/approval", {
						approved: true,
						processId: res.data.data
					}).then(() => {
						this.getAll()
					})
				})
			},
			ok() {
				this.show = false;
				this.loading = true;
				if (this.title == "新增") {
					let formatsTags = JSON.stringify(this.form.formatsTags);
					let qianyueTime = "";
					let endingTime = ""
					if (this.form.qianyueTime) {
						qianyueTime = new Date(this.form.qianyueTime).getTime()
					}
					if (this.form.endingTime) {
						endingTime = new Date(this.form.endingTime).getTime()
					}
					this.$http.post("/api/contract/add", {
						...this.form,
						formatsTags,
						qianyueTime,
						endingTime
					}).then(res => {
						if (res.data.code == 0) {
							// this.$message.success("操作成功")
							this.xa(res.data.data);
							// this.getAll()
						} else {
							this.loading = false
							this.$message.error(res.data.message)
						}
					})
				}
				if (this.title == "变更") {
					let url = "";
					if (this.name == "合同变更") {
						url = "/api/contract/update"
					}
					if (this.name == "合同续签") {
						url = "/api/contract/updateXuQian"
					}
					if (this.name == "补充协议") {
						url = "/api/contract/updateXieYi"
					}
					if (this.name == "合同解约") {
						// url = "/api/contract/updateJieYue"
						url = "/api/contract/deleteJieYue"
						if (this.bg.terminationReason == "") {
							this.$message.warning("请填写解约原因")
							return
						}
					}
					let formatsTags = JSON.stringify(this.bg.formatsTags);
					let qianyueTime = "";
					let endingTime = ""
					if (this.bg.qianyueTime) {
						qianyueTime = new Date(this.bg.qianyueTime).getTime()
					}
					if (this.bg.endingTime) {
						endingTime = new Date(this.bg.endingTime).getTime()
					}
					this.$http.post(url, {
						...this.bg,
						formatsTags,
						qianyueTime,
						endingTime
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success("操作成功")
							// this.getAll()
							if (this.name == "合同解约") {
								this.loading = false
								this.getAll()
								return
							}
							this.xa(res.data.data);
						} else {
							this.$message.error(res.data.message)
						}
					})
				}

			},
			addRow() {
				this.form = JSON.parse(JSON.stringify(this.oldForm))
				this.show = true;
				this.title = '新增';
			},
			success(res) {
				if (res.code == 0) {
					if (this.title == "新增") {
						this.form.contractAttachment = res.data.filePath
						this.form.contractAttachmentFilename = res.data.fileName
					}
					if (this.title == "变更") {
						this.bg.contractAttachment = res.data.filePath
						this.bg.contractAttachmentFilename = res.data.fileName
					}
					this.$message.success(res.message)
				} else {
					this.$message.error(res.message)
				}
			},
			success2(res) {
				if (res.code == 0) {
					if (this.title == "新增") {
						this.form.contractYxs = res.data.filePath
						this.form.contractYxsFilename = res.data.fileName
					}
					if (this.title == "变更") {
						this.bg.contractAttachment = res.data.filePath
						this.bg.contractAttachmentFilename = res.data.fileName
					}
					this.$message.success(res.message)
				} else {
					this.$message.error(res.message)
				}
			},
			getAll() {
				let qianyueTime = ""
				if (this.sf.qianyueTime) {
					qianyueTime = new Date(this.sf.qianyueTime)
				}
				this.$http.post("/api/contract/selectByPage", {
					...this.sf,
					qianyueTime
				}).then(res => {
					this.loading = false;
					
					if (res.data.code == 0) {
						
						this.data = res.data.data.items;
						this.count = res.data.data.totalNum;
						this.$message.success("操作成功")
					} else {
						this.$message.warning(res.data.message)
						this.data = res.data.data
					}
				})
			},
			getNum() { //获取商铺号
				this.$http.get('/api/bdShop/getShops').then(res => {
					this.nums = res.data.data
				})
			}
		},
		created() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
			this.getAll()
			this.getNum()
		}
	}
</script>

<style scoped="scoped">
</style>
